<script lang="ts">
import './Spinner.css'

import { defineComponent } from 'vue-demi'

export default defineComponent({
  components: {},
  props: {
    width: {type: Number, required: true},
    height: {type: Number, required: true},
  },
  setup() {
    return {}
  },
})
</script>

<template>
  <div
    class="cSpinner"
    :style="{ width: `${$props.width}px`, height: `${$props.height}px` }"
  >
    <div
      :style="{
        margin: `${$props.width / 8}px`,
        'border-width': `${$props.width / 8}px`,
      }"
    />
    <div
      :style="{
        margin: `${$props.width / 8}px`,
        'border-width': `${$props.width / 8}px`,
      }"
    />
    <div
      :style="{
        margin: `${$props.width / 8}px`,
        'border-width': `${$props.width / 8}px`,
      }"
    />
    <div
      :style="{
        margin: `${$props.width / 8}px`,
        'border-width': `${$props.width / 8}px`,
      }"
    />
  </div>
</template>
